<div class="overflow-hidden bg-white shadow-sm sm:rounded-lg h-full">
  <div class="p-3">
    <!-- Accordion Item 1 -->
    <div class="border-b border-slate-200">
      <button onclick="toggleAccordion(1)" class="w-full flex justify-between items-center py-5 text-slate-800">
        <!-- LEFT GROUP -->
        <div class="flex items-center gap-3">
          <div class="step-number">1</div>
          <span><strong>Height-</strong> {{selectedHeight()}}" High</span>
        </div>

        <span id="icon-1" class="text-slate-800 transition-transform duration-300">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
        <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
      </svg>
    </span>
      </button>
      <div id="content-1" class="max-h-0 overflow-hidden transition-all duration-300 ease-in-out">
        <div class="accordion-inner h-50 overflow-y-auto px-4 pb-4">
          <app-height></app-height>
          </div>
      </div>
    </div>

    <!-- Accordion Item 2 -->
    <div class="border-b border-slate-200">
      <button onclick="toggleAccordion(2)" class="w-full flex justify-between items-center py-5 text-slate-800">
        <!-- LEFT GROUP -->
        <div class="flex items-center gap-3">
          <div class="step-number">2</div>
          <span><strong>Panel Style-</strong> {{selectedPanelStyle()}}</span>
        </div>

        <span id="icon-2" class="text-slate-800 transition-transform duration-300">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
        <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
      </svg>
    </span>
      </button>
      <div id="content-2" class="max-h-0 overflow-hidden transition-all duration-300 ease-in-out">
        <div class="accordion-inner h-50 overflow-y-auto px-4 pb-4">
          <app-panel-styles></app-panel-styles>
        </div>
      </div>
    </div>

    @for (s of selections(); track s.zone; let i = $index) {
      <div class="border-b border-slate-200">
        <button
          (click)="toggleAccordion(i+3)"
          class="w-full flex justify-between items-center py-5 text-slate-800"
        >
          <!-- LEFT GROUP -->
          <div class="flex items-center gap-3" style="padding-left:45px;">
            <div class="step-number">2{{ subSteps[i] }}</div>
            <span>
            <strong>{{ s.zone }}-</strong>
              @if (s.type && s.color) {
                {{ s.type | titlecase }} –
                {{ materialService.getColorLabel(s.type, s.color) }}
              } @else if (s.type) {
                {{ s.type | titlecase }} (no color selected)
              } @else {
                Not selected
              }
          </span>
          </div>

          <span id="icon-{{i+3}}" class="text-slate-800 transition-transform duration-300">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
            <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
          </svg>
        </span>
        </button>
        <div id="content-{{i+3}}" class="max-h-0 overflow-hidden transition-all duration-300 ease-in-out">
          <div class="accordion-inner h-70 overflow-y-auto px-4 pb-4">
            <app-material zone="{{s.zone}}"></app-material>
          </div>
        </div>
      </div>
    }

    <!-- Accordion Item 3 -->
    <div class="border-b border-slate-200">
      <button onclick="toggleAccordion(8)" class="w-full flex justify-between items-center py-5 text-slate-800">
        <!-- LEFT GROUP -->
        <div class="flex items-center gap-3">
          <div class="step-number">3</div>
          <span><strong>Worksurface Color-</strong> {{selectedWorksurface().name}} ({{selectedWorksurface().code}})</span>
        </div>

        <!-- RIGHT ICON -->
        <span id="icon-8" class="text-slate-800 transition-transform duration-300">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
        <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
      </svg>
    </span>
      </button>
      <div id="content-8" class="max-h-0 overflow-hidden transition-all duration-300 ease-in-out">
        <div class="accordion-inner">
          <app-worksurface></app-worksurface>
        </div>
      </div>
    </div>

    <div class="border-b border-slate-200">
      <button onclick="toggleAccordion(9)" class="w-full flex justify-between items-center py-5 text-slate-800">
        <!-- LEFT GROUP -->
        <div class="flex items-center gap-3">
          <div class="step-number">4</div>
          <span><strong>Door-</strong> {{selectedDoor().door.name}}- {{selectedDoor().doorColor?.color}}</span>
        </div>

        <!-- RIGHT ICON -->
        <span id="icon-9" class="text-slate-800 transition-transform duration-300">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
        <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
      </svg>
    </span>
      </button>
      <div id="content-9" class="max-h-0 overflow-hidden transition-all duration-300 ease-in-out">
        <div class="accordion-inner">
          <app-door></app-door>
        </div>
      </div>
    </div>

    <div class="border-b border-slate-200">
      <button onclick="toggleAccordion(10)" class="w-full flex justify-between items-center py-5 text-slate-800">
        <!-- LEFT GROUP -->
        <div class="flex items-center gap-3">
          <div class="step-number">5</div>
          <span><strong>Download/Email</strong></span>
        </div>

        <!-- RIGHT ICON -->
        <span id="icon-10" class="text-slate-800 transition-transform duration-300">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4">
        <path d="M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" />
      </svg>
    </span>
      </button>
      <div id="content-10" class="max-h-0 overflow-hidden transition-all duration-300 ease-in-out">
        <div class="accordion-inner">
          <form>
            <div class="space-y-12">

              <div class="border-b border-gray-900/10 pb-12">
                <!-- Begin Success Message -->
                <div class="rounded-md bg-green-50 p-4 hidden" id="email_good">
                  <div class="flex">
                    <div class="shrink-0">
                      <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5 text-green-400">
                        <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd" fill-rule="evenodd" />
                      </svg>
                    </div>
                    <div class="ml-3">
                      <h3 class="text-sm font-medium text-green-800">Message Sent</h3>
                      <div class="mt-2 text-sm text-green-700">
                        <p>Your custom panel design has been successfully sent.</p>
                      </div>
                      <div class="mt-4">
                        <div class="-mx-2 -my-1.5 flex">
                          <button
                            type="button"
                            (click)="hideSuccess()"
                            class="ml-3 rounded-md bg-green-50 px-2 py-1.5 text-sm font-medium text-green-800 hover:bg-green-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                          >
                            Dismiss
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Success Message -->
                <h2 class="text-base/7 font-semibold text-gray-900">Your Information</h2>
                <div class="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                  <div class="sm:col-span-3">
                    <label for="first-name" class="block text-sm/6 font-medium text-gray-900">First name</label>
                    <div class="mt-2">
                      <input id="first-name" type="text" name="first-name" autocomplete="given-name" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                    </div>
                  </div>

                  <div class="sm:col-span-3">
                    <label for="last-name" class="block text-sm/6 font-medium text-gray-900">Last name</label>
                    <div class="mt-2">
                      <input id="last-name" type="text" name="last-name" autocomplete="family-name" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                    </div>
                  </div>

                  <div class="sm:col-span-4">
                    <label for="email" class="block text-sm/6 font-medium text-gray-900">Email address</label>
                    <div class="mt-2">
                      <input id="email" type="email" name="email" autocomplete="email" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6" />
                    </div>
                  </div>
                </div>
              </div>


            </div>

            <div class="mt-6 flex items-center justify-end gap-x-6">
              <input type="hidden" id="door_type" value="{{selectedDoor().door.code}}" />
              <input type="hidden" id="door_color" value="{{selectedDoor().doorColor?.code}}" />
              <input type="hidden" id="height" value="{{selectedHeight()}}" />
              <input type="hidden" id="style" value="{{selectedPanelStyle()}}" />
              @for (s of selections(); track s.zone) {
                <input type="hidden" id="{{s.zone}}" value="{{s.color}}" />
              }
              <input type="hidden" id="worksurface" value="{{selectedWorksurface().code}}" />
              <button (click)="downloadPanel()"
                      type="button"
                      class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                Download Panel
              </button>
              <button (click)="emailSelection()"
                      type="button"
                      id="send_email"
                      class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-gray-400 disabled:cursor-not-allowed">
                Send
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</div>
